import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const LaunchPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [newsletterStatus, setNewsletterStatus] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    setNewsletterStatus('success');
    setEmail('');
    setTimeout(() => setNewsletterStatus(''), 3000);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search-results?q=${encodeURIComponent(searchQuery)}&page=1`);
    }
  };

  const styles = {
    page: {
      minHeight: '100vh',
      background: '#fff',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    header: {
      position: 'sticky',
      top: 0,
      background: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      borderBottom: '1px solid #e8e8e8',
      padding: '1rem 0',
      zIndex: 100,
    },
    navContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 2rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    logo: {
      fontSize: '1.5rem',
      fontWeight: '700',
      color: '#FF385C',
      textDecoration: 'none',
    },
    navLinks: {
      display: 'flex',
      gap: '2rem',
      alignItems: 'center',
    },
    navLink: {
      textDecoration: 'none',
      color: '#333',
      fontWeight: '500',
      transition: 'color 0.2s',
      cursor: 'pointer',
    },
    hero: {
      position: 'relative',
      height: '60vh',
      minHeight: '500px',
      background: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), 
                  url('https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80') center/cover`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      textAlign: 'center',
    },
    heroContent: {
      maxWidth: '800px',
      padding: '0 2rem',
    },
    heroTitle: {
      fontSize: '3.5rem',
      fontWeight: '700',
      marginBottom: '1rem',
      textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
    },
    heroSubtitle: {
      fontSize: '1.3rem',
      fontWeight: '300',
      marginBottom: '2rem',
      textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
    },
    heroButtons: {
      display: 'flex',
      gap: '1rem',
      justifyContent: 'center',
      flexWrap: 'wrap',
      marginBottom: '2rem',
    },
    btnPrimary: {
      padding: '0.8rem 2rem',
      background: '#FF385C',
      color: 'white',
      border: 'none',
      borderRadius: '25px',
      fontWeight: '600',
      textDecoration: 'none',
      display: 'inline-block',
      transition: 'all 0.2s',
      cursor: 'pointer',
    },
    btnSecondary: {
      padding: '0.8rem 2rem',
      background: 'transparent',
      color: 'white',
      border: '2px solid white',
      borderRadius: '25px',
      fontWeight: '600',
      textDecoration: 'none',
      display: 'inline-block',
      transition: 'all 0.2s',
      cursor: 'pointer',
    },
    searchContainer: {
      marginTop: '1rem',
      maxWidth: '500px',
      margin: '0 auto',
    },
    searchForm: {
      display: 'flex',
      gap: '0',
      background: 'rgba(255, 56, 92, 0.15)',
      backdropFilter: 'blur(10px)',
      borderRadius: '30px',
      overflow: 'hidden',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
    },
    searchInput: {
      flex: 1,
      padding: '0.8rem 1.5rem',
      border: 'none',
      fontSize: '1rem',
      outline: 'none',
      background: 'transparent',
      color: 'white',
    },
    searchButton: {
      padding: '0.8rem 1.5rem',
      background: '#FF385C',
      color: 'white',
      border: 'none',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.2s',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
    mainContent: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '4rem 2rem',
    },
    sectionHeader: {
      marginBottom: '3rem',
      textAlign: 'center',
    },
    sectionTitle: {
      fontSize: '2rem',
      fontWeight: '600',
      marginBottom: '0.5rem',
      color: '#333',
    },
    sectionDescription: {
      fontSize: '1.1rem',
      color: '#666',
    },
    citiesGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 350px), 1fr))',
      gap: '2rem',
      marginBottom: '4rem',
    },
    cityCard: {
      background: 'white',
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
      transition: 'all 0.3s ease',
      cursor: 'pointer',
      border: '1px solid #e8e8e8',
      textDecoration: 'none',
      color: 'inherit',
    },
    cityCardDisabled: {
      opacity: 0.7,
      cursor: 'not-allowed',
    },
    cityImage: {
      height: '250px',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      position: 'relative',
    },
    cityBadge: {
      position: 'absolute',
      top: '12px',
      right: '12px',
      background: 'rgba(255, 255, 255, 0.9)',
      padding: '6px 12px',
      borderRadius: '20px',
      fontSize: '0.85rem',
      fontWeight: '600',
      color: '#FF385C',
    },
    cityBadgeComingSoon: {
      background: 'rgba(0,0,0,0.7)',
      color: 'white',
    },
    cityInfo: {
      padding: '1.5rem',
    },
    cityName: {
      fontSize: '1.5rem',
      fontWeight: '600',
      marginBottom: '0.5rem',
      color: '#333',
    },
    cityDetails: {
      color: '#666',
      fontSize: '0.95rem',
      marginBottom: '1rem',
    },
    cityStats: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontSize: '0.9rem',
    },
    featuresGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
      gap: '2rem',
      marginBottom: '4rem',
    },
    featureCard: {
      background: 'white',
      borderRadius: '12px',
      padding: '2rem',
      boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
      transition: 'all 0.3s ease',
      border: '1px solid #e8e8e8',
      textAlign: 'center',
    },
    featureIcon: {
      width: '60px',
      height: '60px',
      margin: '0 auto 1.5rem',
      background: '#FF385C',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    featureTitle: {
      fontSize: '1.2rem',
      fontWeight: '600',
      marginBottom: '1rem',
      color: '#333',
    },
    featureText: {
      color: '#666',
      lineHeight: '1.6',
    },
    newsletterSection: {
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      borderRadius: '12px',
      padding: '3rem',
      marginBottom: '4rem',
      textAlign: 'center',
      color: 'white',
    },
    newsletterForm: {
      display: 'flex',
      gap: '1rem',
      maxWidth: '500px',
      margin: '2rem auto 0',
    },
    newsletterInput: {
      flex: 1,
      padding: '0.8rem 1.2rem',
      border: 'none',
      borderRadius: '25px',
      fontSize: '1rem',
    },
    newsletterBtn: {
      padding: '0.8rem 2rem',
      background: 'white',
      color: '#667eea',
      border: 'none',
      borderRadius: '25px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.2s',
    },
    successMessage: {
      marginTop: '1rem',
      padding: '0.8rem',
      background: 'rgba(255,255,255,0.2)',
      borderRadius: '8px',
    },
  };

  return (
    <div style={styles.page}>
      {/* Sticky Header */}
      <header style={styles.header}>
        <div style={styles.navContainer}>
          <Link to="/" style={styles.logo}>StoreToyou</Link>
          <nav style={styles.navLinks}>
            <a href="#cities" style={styles.navLink}>Cities</a>
            <a href="#features" style={styles.navLink}>Features</a>
            <a href="#how-it-works" style={styles.navLink}>How It Works</a>
            <Link to="/dashboard" style={styles.navLink}>Dashboard</Link>
            <Link to="/login" style={styles.navLink}>Login</Link>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section style={styles.hero}>
        <div style={styles.heroContent}>
          <h1 style={styles.heroTitle}>Discover Your City's Hidden Gems</h1>
          <p style={styles.heroSubtitle}>
            Bridge local businesses and communities with Instagram-inspired visual discovery
          </p>
          <div style={styles.heroButtons}>
            <Link to="/createstore" style={styles.btnPrimary}>Create Your Store</Link>
            <a href="#cities" style={styles.btnSecondary}>Browse Cities</a>
          </div>
          
          {/* Search Bar */}
          <div style={styles.searchContainer}>
            <form style={styles.searchForm} onSubmit={handleSearchSubmit}>
              <input
                type="text"
                style={styles.searchInput}
                placeholder="Search products, services, experiences..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button 
                type="submit" 
                style={styles.searchButton}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#e03348';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '#FF385C';
                }}
              >
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M11 2a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm0 16a7 7 0 1 1 7-7 7 7 0 0 1-7 7z"/>
                  <path d="m21.71 20.29-4.6-4.6a.93.93 0 0 0-1.41 0 1 1 0 0 0 0 1.41l4.6 4.6a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41z"/>
                </svg>
                Search
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <main style={styles.mainContent}>
        {/* Cities Section */}
        <section id="cities">
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle}>Available Cities</h2>
            <p style={styles.sectionDescription}>
              Explore hyperlocal commerce in these communities
            </p>
          </div>
          
          <div className="cities-grid" style={styles.citiesGrid}>
            <Link
              to="/city/vancouver"
              style={styles.cityCard}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.1)';
              }}
            >
              {/* Vancouver skyline from Stanley Park — Joshua Webb / Unsplash (yhz9bL5OluQ) */}
              <div role="img" aria-label="Vancouver skyline from Stanley Park" style={{
                ...styles.cityImage,
                backgroundImage: `url('https://images.unsplash.com/photo-1660220375737-23676cdb612b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80')`,
              }}>
                <div style={styles.cityBadge}>Now Live!</div>
              </div>
              <div style={styles.cityInfo}>
                <h3 style={styles.cityName}>Vancouver</h3>
                <p style={styles.cityDetails}>
                  Discover local shops, products, and experiences in Vancouver.
                </p>
                <div style={styles.cityStats}>
                  <span style={{ color: '#FF385C', fontWeight: '500' }}>Explore →</span>
                </div>
              </div>
            </Link>

            <Link 
              to="/city/kelowna" 
              style={styles.cityCard}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.1)';
              }}
            >
              <div style={{
                ...styles.cityImage,
                backgroundImage: `url('https://images.unsplash.com/photo-1559329007-40df8a9345d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80')`,
              }}>
                <div style={styles.cityBadge}>Now Live!</div>
              </div>
              <div style={styles.cityInfo}>
                <h3 style={styles.cityName}>Kelowna</h3>
                <p style={styles.cityDetails}>
                  Discover products, services, and experiences in the Okanagan Valley
                </p>
                <div style={styles.cityStats}>
                  <span style={{ color: '#FF385C', fontWeight: '500' }}>Explore →</span>
                  <span style={{ color: '#666' }}>25+ stores</span>
                </div>
              </div>
            </Link>

            <div style={{ ...styles.cityCard, ...styles.cityCardDisabled }}>
              <div style={{
                ...styles.cityImage,
                backgroundImage: `url('https://images.unsplash.com/photo-1517935706615-2717063c2225?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80')`,
              }}>
                <div style={{ ...styles.cityBadge, ...styles.cityBadgeComingSoon }}>Coming Soon</div>
              </div>
              <div style={styles.cityInfo}>
                <h3 style={styles.cityName}>Penticton</h3>
                <p style={styles.cityDetails}>Local gems in beach city charm</p>
                <div style={styles.cityStats}>
                  <span style={{ color: '#999' }}>Coming Soon</span>
                </div>
              </div>
            </div>

            <div style={{ ...styles.cityCard, ...styles.cityCardDisabled }}>
              <div style={{
                ...styles.cityImage,
                backgroundImage: `url('https://images.unsplash.com/photo-1503614472-8c93d56e92ce?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80')`,
              }}>
                <div style={{ ...styles.cityBadge, ...styles.cityBadgeComingSoon }}>Coming Soon</div>
              </div>
              <div style={styles.cityInfo}>
                <h3 style={styles.cityName}>Vernon</h3>
                <p style={styles.cityDetails}>Products, services, experiences amid lakes and mountains</p>
                <div style={styles.cityStats}>
                  <span style={{ color: '#999' }}>Coming Soon</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section id="features">
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle}>Why StoreToyou?</h2>
            <p style={styles.sectionDescription}>
              Instagram for local commerce: Visual discovery of products, services, experiences
            </p>
          </div>
          
          <div style={styles.featuresGrid}>
            <div 
              style={styles.featureCard}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.1)';
              }}
            >
              <div style={styles.featureIcon}>
                <svg width="30" height="30" fill="white" viewBox="0 0 24 24">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
              </div>
              <h3 style={styles.featureTitle}>Location-First Architecture</h3>
              <p style={styles.featureText}>
                City-based URLs for hyperlocal discovery
              </p>
            </div>

            <div 
              style={styles.featureCard}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.1)';
              }}
            >
              <div style={styles.featureIcon}>
                <svg width="30" height="30" fill="white" viewBox="0 0 24 24">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                  <line x1="7" y1="7" x2="17" y2="7" stroke="white" strokeWidth="2"/>
                  <line x1="7" y1="12" x2="17" y2="12" stroke="white" strokeWidth="2"/>
                  <line x1="7" y1="17" x2="17" y2="17" stroke="white" strokeWidth="2"/>
                </svg>
              </div>
              <h3 style={styles.featureTitle}>Instagram-Style Experience</h3>
              <p style={styles.featureText}>
                Visual grids and stories for business discovery
              </p>
            </div>

            <div 
              style={styles.featureCard}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.1)';
              }}
            >
              <div style={styles.featureIcon}>
                <svg width="30" height="30" fill="white" viewBox="0 0 24 24">
                  <path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8"/>
                  <polyline points="16 6 12 2 8 6"/>
                  <line x1="12" y1="10" x2="12" y2="22"/>
                </svg>
              </div>
              <h3 style={styles.featureTitle}>Three-Tier Categories</h3>
              <p style={styles.featureText}>
                Products, services, and experiences in one place
              </p>
            </div>

            <div 
              style={styles.featureCard}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.1)';
              }}
            >
              <div style={styles.featureIcon}>
                <svg width="30" height="30" fill="white" viewBox="0 0 24 24">
                  <rect x="3" y="11" width="18" height="10" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0110 0v4" fill="none" stroke="white" strokeWidth="2"/>
                </svg>
              </div>
              <h3 style={styles.featureTitle}>Simplified Management</h3>
              <p style={styles.featureText}>
                Easy dashboard for content and store updates
              </p>
            </div>

            <div 
              style={styles.featureCard}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.1)';
              }}
            >
              <div style={styles.featureIcon}>
                <svg width="30" height="30" fill="white" viewBox="0 0 24 24">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <h3 style={styles.featureTitle}>Community Connection</h3>
              <p style={styles.featureText}>
                Build relationships with local customers
              </p>
            </div>

            <div 
              style={styles.featureCard}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.1)';
              }}
            >
              <div style={styles.featureIcon}>
                <svg width="30" height="30" fill="white" viewBox="0 0 24 24">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01" fill="none" stroke="white" strokeWidth="2"/>
                </svg>
              </div>
              <h3 style={styles.featureTitle}>Local SEO Optimized</h3>
              <p style={styles.featureText}>
                City URLs boost Google visibility
              </p>
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section id="how-it-works">
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle}>How It Works</h2>
            <p style={styles.sectionDescription}>
              Start your visual discovery journey in three steps
            </p>
          </div>
          
          <div style={styles.featuresGrid}>
            <div style={styles.featureCard}>
              <div style={styles.featureIcon}>
                <span style={{ color: 'white', fontSize: '1.5rem', fontWeight: 'bold' }}>1</span>
              </div>
              <h3 style={styles.featureTitle}>Sign Up</h3>
              <p style={styles.featureText}>
                Create account and select city URL
              </p>
            </div>

            <div style={styles.featureCard}>
              <div style={styles.featureIcon}>
                <span style={{ color: 'white', fontSize: '1.5rem', fontWeight: 'bold' }}>2</span>
              </div>
              <h3 style={styles.featureTitle}>Add Items</h3>
              <p style={styles.featureText}>
                Upload photos for products, services, experiences
              </p>
            </div>

            <div style={styles.featureCard}>
              <div style={styles.featureIcon}>
                <span style={{ color: 'white', fontSize: '1.5rem', fontWeight: 'bold' }}>3</span>
              </div>
              <h3 style={styles.featureTitle}>Go Live</h3>
              <p style={styles.featureText}>
                Share store and connect locally
              </p>
            </div>
          </div>
        </section>

        {/* Newsletter Section */}
        <section style={styles.newsletterSection}>
          <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Stay Updated</h2>
          <p style={{ fontSize: '1.1rem', marginBottom: '2rem' }}>
            Get launch alerts and local business growth tips
          </p>
          <form style={styles.newsletterForm} onSubmit={handleNewsletterSubmit}>
            <input 
              type="email" 
              style={styles.newsletterInput} 
              placeholder="Enter your email" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required 
            />
            <button 
              type="submit" 
              style={styles.newsletterBtn}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              Subscribe
            </button>
          </form>
          {newsletterStatus === 'success' && (
            <div style={styles.successMessage}>
              Thank you for subscribing! We'll keep you updated.
            </div>
          )}
        </section>
      </main>


      {/* Media Query Styles */}
      <style>{`
        @media (max-width: 768px) {
          .hero-title { font-size: 2.5rem !important; }
          .nav-links { gap: 1rem !important; }
          .nav-link { font-size: 0.9rem !important; }
          .cities-grid { grid-template-columns: 1fr !important; }
          .newsletter-form { flex-direction: column !important; }
          .hero-buttons { flex-direction: column !important; align-items: center !important; }
          .features-grid { grid-template-columns: 1fr !important; }
        }
        
        @media (max-width: 480px) {
          .hero-title { font-size: 2rem !important; }
          .hero-subtitle { font-size: 1.1rem !important; }
          .section-title { font-size: 1.5rem !important; }
          .nav-container { padding: 0 1rem !important; }
          .main-content { padding: 3rem 1rem !important; }
        }
      `}</style>
    </div>
  );
};

export default LaunchPage;